// React
import React from 'react';
import { useTranslation } from 'react-i18next';

// Libs
import { Card, Table } from 'semantic-ui-react';

// Components
import CopyContentComponent from '../../../misc/CopyContent.component';

// Types
import { customerBankAccountState } from '../../../../model/details/bankAccountState';
import { BankAccountState } from '../../../../types/BankAccount';

type LeadBankAccountComponentProps = {
    data: typeof customerBankAccountState;
    copy?: boolean;
};

/**
 * Box shows bank account informations. Set range in `matrix` variable.
 *
 * @param props LeadBankAccountComponentProps
 * @returns React.ReactElement
 */
export default function LeadBankAccountComponent(props: LeadBankAccountComponentProps): React.ReactElement {
    const { t } = useTranslation();

    const matrix: Array<keyof BankAccountState> = ['bankAccountOwner', 'bankName', 'iban', 'bic'];

    function createValue(value: string): React.ReactElement {
        return props.copy ? <CopyContentComponent>{value}</CopyContentComponent> : <>{value || ''}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.bankAccount.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            {matrix.map((key: string, ix) => (
                                <Table.Row key={ix}>
                                    <Table.Cell width={4}>{t(`lead.detail.box.bankAccount.${key}`)}</Table.Cell>
                                    <Table.Cell singleLine>{createValue(props.data[key])}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
